import { useState } from "react"
import { Modal } from "react-bootstrap"
import { PageTitle } from "../../../../_metronic/layout/core"
import PermissionsGate from "../../../api/PermissionsGate"
import { SCOPES } from "../../../config/permissions-map"
import { Unauthorized } from "../../Global/unauthorized"
import AnioComparativo from "./AnioComparativo"
import CargaAllIn from "./CargaAllIn"
import CierreMes from "./CierreMes"
import ContratosSimiles from "./ContratosSimiles"

export default function SuperAdmin({ title }) {
    const [saved, setSaved] = useState(false)
    function guardadoExistosoModal() {
        setSaved(false);
        window.location.reload(false);
    }
    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.VISTA_AMONESTACIONES]} >
                <PageTitle>{title}</PageTitle>
                <div className="card my-5">
                    <div className="card-body">
                        <div className="row g-2">
                            <div className="col-sm-6">
                                <CierreMes setSaved={setSaved} />
                            </div>
                            <div className="col-sm-6">
                                <AnioComparativo setSaved={setSaved} />
                            </div>
                            
                            
                            {/* <MantenimietnoTiendas setSaved={setSaved} /> */}

                        </div>
                    </div>
                </div>
                <div className="card my-5">
                    <div className="card-body">

                        <CargaAllIn></CargaAllIn>

                    </div>
                </div>
                <ContratosSimiles></ContratosSimiles>
                <Modal
                    size="sm"
                    show={saved}
                    onHide={() => setSaved(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                            Guardado Exitoso
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer style={{ margin: 'auto' }}>
                        <button type="button" className="btn btn-primary" onClick={guardadoExistosoModal}>
                            Aceptar
                        </button>
                    </Modal.Footer>
                </Modal>
            </PermissionsGate>
        </>
    )
}


